import React, { useEffect } from 'react';
import Base from './pages/Base/Base';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './hive/theme/hive.css';
import { store, persistor } from './redux/store/';

import Loading from './components/loading/Loading';
import ScrollToTop from "./ScrollToTop";
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
function App() {
    // Fade the static splash (rendered in index.html before React boots)
    // out once the tree has mounted. Min display time keeps it from
    // flickering on cached/fast loads.
    useEffect(() => {
        const splash = typeof document !== 'undefined'
            ? document.getElementById('bnxa-splash')
            : null;
        if (!splash) return;
        const minVisibleMs = 600;
        const start = performance.now();
        const elapsed = performance.now() - start;
        const wait = Math.max(0, minVisibleMs - elapsed);
        const hideTimer = setTimeout(() => {
            splash.classList.add('bnxa-splash-hidden');
            const removeTimer = setTimeout(() => {
                if (splash.parentNode) splash.parentNode.removeChild(splash);
            }, 600);
            splash._removeTimer = removeTimer;
        }, wait);
        return () => clearTimeout(hideTimer);
    }, []);

    const theme = createTheme({
        palette: {
            primary: {
                main: '#355942',
            },
            secondary: {
                main: '#95bcb8',
            },
            error: {
                main: '#f50057'
            },
            tertiary: {
                main: '#e3d507'
            }

        },
    });
  return (
    <div className='shipment-background'>
      <Provider store={store}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <BrowserRouter>
            <ScrollToTop>
              <ThemeProvider theme={theme}>
                  <Base />
              </ThemeProvider>
            </ScrollToTop>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
